"use strict";function getLoadTime$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getLoadTime$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="runtime.monitor.getLoadTime";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.0.10"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.10"},_a)),exports.getLoadTime$=getLoadTime$,exports.default=getLoadTime$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/runtime/monitor/getLoadTime.js
// module id = 1088
// module chunks = 106